module.exports = __webpack_public_path__ + "3f16e137/img/cadBim.e369a02a.png";